import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Chip, } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChevronLeft, Copy, User } from 'react-feather';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useSelector } from 'react-redux';
import { authApi } from '../../api/api';
import { Tooltip, Snackbar } from '@mui/material';


export default function FirmDetails() {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const userID = useSelector((state_id) => state_id.auth.id);
    const token = useSelector((state_id) => state_id.auth.token);
    const { userId } = location.state || {};

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const [formData, setFormData] = useState({
        userName: '',
        email: '',
        contactNumber: '',
        altContactNumber: '',
        address: '',
        profileImg: '',
        city: '',
        state: { id: '', state_name: '', shortCode: '' },
        country: { id: 1, name: 'USA' },
        pinCode: '',
        initials: '',
        userRole: '',
        professionalType: '',
        bankDetails: '',
        accountEmail: '',
        password: '',
        confirmPassword: '',
        isActive: false,
    });



    useEffect(() => {
        viewClient(userId)
    }, [userId])

    const handleClickEdit = () => {
        navigate('/edituser', { state: { userId: userId } });
    };
    const handleBack = () => {
        setTimeout(() => navigate(-1), 2000);
    };


    const handleCopy = async () => {
        const textToCopy = `username: ${formData.userName}, password: ${formData.password}`;

        try {
            await navigator.clipboard.writeText(textToCopy);
            setSnackbarMessage('Text copied to clipboard!');
            setOpenSnackbar(true);
        } catch (err) {
            setSnackbarMessage('Failed to copy text.');
            setOpenSnackbar(true);
        }
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    const viewClient = async (userId) => {
        const input_token = `${userId}FIRM_EMP_DETAIL`;
        const apiUrl = 'view_firm_employee'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            id: userId,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setFormData({
                    ...formData,
                    userName: data.client_detail.full_name,
                    email: data.client_detail.email,
                    contactNumber: data.client_detail.phone_number,
                    altContactNumber: data.client_detail.alt_phone_number,
                    address: data.client_detail.address,
                    profileImg: data.client_detail.profile_image,
                    bankDetails:data.client_detail.bankDetails,
                    city: data.client_detail.city,
                    state: { id: data.client_detail.state_id, state_name: data.client_detail.state_name, shortCode: '' },
                    country: { id: 1, name: 'USA' },
                    pinCode: data.client_detail.zip_code,
                    initials: data.client_detail.initial,
                    gender:data.client_detail.gender,
                    userRole: data.client_detail.role_name,
                    professionalType: data.client_detail.designation_name,
                    bankDetails: data.client_detail.bank_details,
                    accountEmail: '',
                    password: data.client_detail.password,
                    confirmPassword: '',
                    isActive: !!data.client_detail.status,
                })
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    return (

        <Box>
             <Box className="title_head"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: '#333333' }} />
                    <Typography fontSize={12} color="#333333">
                        Add New User
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/user"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to User List
                </Button>
            </Box>
       

        <Box className="card-box" p={3} sx={{ borderRadius: '8px', border: '1px solid var(--border-color)', m: 3 }} >
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                message={snackbarMessage}
            />
            <Box className="sub-header">
                <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                    View User
                </Typography>
                <Typography
                    sx={{ fontWeight: 'bold' }}
                >
                    Account status: <span sx={{ color: formData.isActive ? 'green' : 'red', backgroundColor: formData.isActive ? 'transparent' : 'red', display: 'inline-block', fontWeight: 'bold' }}>{formData.isActive ? 'Yes' : 'No'}</span>
                </Typography>
            </Box>


            <Box >
                <Grid container spacing={6}>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Name :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.userName}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Email ID :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.email}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Contact Number :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.contactNumber}</Typography>
                    </Grid>

                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Alternative Contact Number :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.altContactNumber}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Gender :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.gender}</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Address :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.address}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Initials :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.initials}</Typography>
                    </Grid>

                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Country :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.country?.name}</Typography>
                    </Grid>

                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>State :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.state?.state_name}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>City :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.city}</Typography>
                    </Grid>

                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Photo : </Typography>
                        <Box component="img" src={formData.profileImg} alt="User Logo" sx={{ width: 100, height: 'auto' }} />
                    </Grid>

                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Pin Code :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.pinCode}</Typography>
                    </Grid>

                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Role :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.userRole}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Designation Type :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.professionalType}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Bank Details :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.bankDetails}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Password :</Typography>
                        <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.password}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Copy login details :</Typography>
                        <Tooltip title="Copy Text">
                            <Button
                               
                                onClick={handleCopy}
                            >
                                <Copy />
                            </Button>
                        </Tooltip>
                    </Grid>

                </Grid>


                {/* Action Buttons */}
                <Box display={'flex'} justifyContent={'center'} gap={2} mt={4}>
                    <Button variant="contained" color="primary" onClick={() => handleClickEdit()}
                        sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--primary-color)', color: '#fff', '&:hover': { backgroundColor: 'var(--primary-color)' } }}

                    >Edit User Details</Button>
                    <Button variant="outlined" onClick={() => handleBack()}
                        sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--back-button)',
                            color: "var(--back-color)", '&:hover': { backgroundColor: 'var(--primary-color)', color: '#fff' } }}
                    ><ChevronLeft size={24} /> Back to User list</Button>
                </Box>
            </Box>
        </Box>

        </Box>
    );
}
